import { Stack, Typography } from '@mui/material';
import { fontWeights } from '@/@mui/tokens/font-weights';

interface KeyValueProps {
  label: string;
  value: string;
}

export const KeyValue = ({ label, value }: KeyValueProps) => (
  <Stack direction={{ md: 'row' }} gap={{ md: 2 }}>
    <Typography fontWeight={fontWeights.fontWeightSemibold} width={200}>
      {label}
    </Typography>
    <Typography flex={1}>{value}</Typography>
  </Stack>
);
